import request from '@/utils/request'

export function getRewardList() {
  return request({
    url: 'api/v1/tetris-reward/list',
    method: 'post'
  })
}

export function updateReward(data) {
  return request({
    url: 'api/v1/tetris-reward/update',
    method: 'post',
    data: data
  })
}

export function exportReward() {
  return request({
    url: 'api/v1/tetris-reward/export',
    method: 'get'
  })
}

export function importReward(data) {
  return request({
    url: 'api/v1/tetris-reward/import',
    method: 'post',
    data: data
  })
}
